import { render, staticRenderFns } from "./LocationTab.vue?vue&type=template&id=3ab32719"
import script from "./LocationTab.vue?vue&type=script&lang=js"
export * from "./LocationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports